// src/routes/useHydratedAccess.ts
import * as React from "react";
import { useAccessStore } from "../lib/store/useAccessStore";

export function useHydratedAccess() {
  const [ready, setReady] = React.useState(
    useAccessStore.persist?.hasHydrated?.() ?? true
  );

  React.useEffect(() => {
    const unsub = useAccessStore.persist?.onFinishHydration?.(() => setReady(true));
    if (useAccessStore.persist?.hasHydrated?.()) setReady(true);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    return () => { unsub && unsub(); };
  }, []);

  return ready;
}